module.exports = __webpack_public_path__ + "media/images/responsive/top/flow_step02-57565ef626269e955ec8d136fc76e365.webp";